import { render, staticRenderFns } from "./OccupancyBasedPromotion.vue?vue&type=template&id=12078f3d&"
import script from "./OccupancyBasedPromotion.vue?vue&type=script&lang=js&"
export * from "./OccupancyBasedPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports